import { IconButton, Spinner } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import styles from './ChatPopup.css';

interface IChatPopupProps {
  isLoading: boolean;
  height?: string;
  url: string;
  onClose(): void;
  onError(): void;
  onLoad(): void;
}

export const ChatPopup: FC<IChatPopupProps> = props => {
  const { isLoading, onClose, onLoad, onError, url, height } = props;

  return (
    <div className={styles['container']} data-testid="ChatPopup" style={{ height }}>
      <span className={styles['close']}>
        <IconButton aria-label="Закрыть" icon={<IconActionClose16 />} onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      <iframe className={styles['iframe']} src={url} onError={onError} onLoad={onLoad} />
    </div>
  );
};
